import {
  Facebook,
  Github,
  Globe,
  Instagram,
  Linkedin,
  Mail,
  Newspaper,
  Phone,
  PlayCircle,
  Send,
  Twitter,
  Youtube,
  type LucideIcon,
} from "lucide-react";

// Lucide não tem logos de marca para WhatsApp/TikTok — SVGs desenhados à mão,
// mesmo padrão já usado para o WhatsAppIcon em src/components/FloatingActions.tsx.
export const WhatsAppIcon = ({ className = "w-6 h-6" }: { className?: string }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
    <path d="M12 0C5.373 0 0 5.373 0 12c0 2.124.558 4.118 1.535 5.845L.057 23.486a.5.5 0 0 0 .612.612l5.701-1.479A11.952 11.952 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.85 0-3.587-.5-5.082-1.375l-.363-.215-3.762.976.999-3.672-.236-.376A9.96 9.96 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" />
  </svg>
);

export const TikTokIcon = ({ className = "w-6 h-6" }: { className?: string }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M16.6 5.82s.51.5 0 0A4.278 4.278 0 0 1 15.54 3h-3.09v12.4a2.592 2.592 0 0 1-2.59 2.5c-1.42 0-2.6-1.16-2.6-2.6 0-1.72 1.66-3.01 3.37-2.48V9.66c-3.45-.46-6.47 2.22-6.47 5.64 0 3.33 2.76 5.7 5.69 5.7 3.14 0 5.69-2.55 5.69-5.7V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3s-1.88.09-3.24-1.48z" />
  </svg>
);

export type BioIconKey =
  | "link"
  | "video"
  | "blog"
  | "email"
  | "phone"
  | "whatsapp"
  | "instagram"
  | "tiktok"
  | "x"
  | "telegram"
  | "facebook"
  | "linkedin"
  | "youtube"
  | "website"
  | "github";

interface BioIconEntry {
  label: string;
  Icon: LucideIcon | (({ className }: { className?: string }) => JSX.Element);
}

export const BIO_ICONS: Record<BioIconKey, BioIconEntry> = {
  link: { label: "Link", Icon: Globe },
  video: { label: "Vídeo", Icon: PlayCircle },
  blog: { label: "Post de blog", Icon: Newspaper },
  email: { label: "E-mail", Icon: Mail },
  phone: { label: "Telefone", Icon: Phone },
  whatsapp: { label: "WhatsApp", Icon: WhatsAppIcon },
  instagram: { label: "Instagram", Icon: Instagram },
  tiktok: { label: "TikTok", Icon: TikTokIcon },
  x: { label: "X (Twitter)", Icon: Twitter },
  telegram: { label: "Telegram", Icon: Send },
  facebook: { label: "Facebook", Icon: Facebook },
  linkedin: { label: "LinkedIn", Icon: Linkedin },
  youtube: { label: "YouTube", Icon: Youtube },
  website: { label: "Site", Icon: Globe },
  github: { label: "GitHub", Icon: Github },
};

export function getBioIcon(key: string | null | undefined): BioIconEntry {
  return (key && BIO_ICONS[key as BioIconKey]) || BIO_ICONS.link;
}
